



<div *ngIf="!success" class="card-container">

  <main class="main-center" role="main" *ngIf="!success">
    
    <section class="form-section" aria-labelledby="form-title">
      
      
      <form class="registration-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <img src="/assets/img/logoc.png" alt="Logo mic" class="logo-mic">
        <div class="options-inline">
          <div>
            <img src="/assets/img/arrow.svg" alt="Logo mic" class="arrow">
          </div>
          <div>
            <p class="login-options-text">{{this.authService.id|| ''}}</p>
          </div>
          
          
         </div>
        <p class="title-text">Escribir Contraseña</p>
        <div class="input-container">
          <input formControlName="password" [formControl]="passwordFormControl" required 
                 placeholder="Contraseña">


        </div>     
         
          <p class="little-text little-text-link">He olvidado mi contraseña</p>
        

        <div class="submit-button-container">
           <button type="submit" class="submit-button" aria-label="Iniciar sesión">
          Iniciar sesión
          </button>
        </div>
    <div class="login-options-container-background">
      <div>
        <p class="login-options-text login-options-text-space">Inicie sesión empleando su dirección de correo electrónico y su contraseña de red.</p>
      </div>
    </div>
      </form>
    </section>

  </main>
  <div style="text-align: center;margin-top: 40px;">
    <img src="/assets/img/success.png" alt="Logo success adidas Sports" class="logo" *ngIf="success">
  </div>

  



